import axios from "axios";
import { StoreAuth } from "@/store/store.auth";
import { GetSelfSystemPermissionsAPI } from "./ProfileAPI/PermissionsAPI/SystemPermissionsAPI/GetSystemSelfPermissions.api";
import { QueryClient } from "@tanstack/react-query";

export const axiosInstance = axios.create({
  baseURL: "https://donya.devtechco.ir/api",
});

axiosInstance.interceptors.request.use((config) => {
  const token = StoreAuth.getState().token;

  if (token && token !== "__next_hmr_refresh_hash__") {
    config.headers.Authorization = ` ${token}`;
  }

  return config;
});

const queryClient = new QueryClient();

axiosInstance.interceptors.response.use(
  (response) => response,

  async (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      StoreAuth.getState().removeToken();
      window.location.replace("/login");

      return Promise.reject(error);
    }

    if (
      status === 403 &&
      !error.config?.url?.includes("/permissions/system/self")
    ) {
      await queryClient.fetchQuery({
        queryKey: ["self-system-permissions"],
        queryFn: GetSelfSystemPermissionsAPI,
      });
    }

    return Promise.reject(error);
  },
);
